import { useState } from "react";
import "primeflex/primeflex.css";
import Services from "../service/ApiServices"

export const useClientService = ()=>{
    const [filteredClient, setFilteredClient] = useState([]);  
  

    const SearchClient = (event)=>{setTimeout(async () => {
        let _filteredClient;
        if (!event.query.trim().length) {
            _filteredClient = [];
        }
        else {            
            _filteredClient = (await Services.Census.getClients(event.query.toLowerCase())).data            
        }
        setFilteredClient(_filteredClient);
    }, 250)};

    const GetClientDetails = async (assignmentId)=>{
        const data =  (await Services.Census.getClientDetails(assignmentId)).data  
        return data;

    }

   

    return   {filteredClient, SearchClient, GetClientDetails}
}


